export const POST_SSO_START = 'POST_SSO_START';
export const POST_SSO_SUCCESS = 'POST_SSO_SUCCESS';
export const POST_SSO_FAIL = 'POST_SSO_FAIL';
